import React, { useContext as useContextCore } from 'react'
import type { UseActionResult, UseListResult } from '@ztechapps/common.hook'
import type { InventoryBySerialNumber, Product, ProductRequiredSerialNumberArgs } from '@ztechapps/common.contract'
import { useInventoryBySerialNumberList } from '@ztechapps/inventorybyserialnumber.common'

export type InventoryBySerialNumberProviderProps = {
  filterCategory?: string
  requiredSerialNumber: boolean
  productId: string
  children: React.ReactNode
  productRequiredSerialNumberActionResult: UseActionResult<Product, ProductRequiredSerialNumberArgs>
}

export type InventoryBySerialNumberListContext = {
  inventorybyserialnumberList: UseListResult<InventoryBySerialNumber>
} & Omit<InventoryBySerialNumberProviderProps, 'children'>

const context = React.createContext<InventoryBySerialNumberListContext>({} as InventoryBySerialNumberListContext)
const CoreProvider = context.Provider

export const InventoryBySerialNumberListProvider = ({
  children,
  productId,
  filterCategory = 'productInventoryBySerialNumberFilterCategory',
  ...props
}: InventoryBySerialNumberProviderProps) => {
  const inventorybyserialnumberList = useInventoryBySerialNumberList({
    filter: { 'product._id': productId },
  })

  return (
    <CoreProvider value={{ inventorybyserialnumberList, productId, filterCategory, ...props }}>{children}</CoreProvider>
  )
}

export const useInventoryBySerialNumberListContext = () => useContextCore(context)
